<template lang="html">

  <section class="ficha-wrapper" :showBotones="showBotonAccionesEvaluadas || showBotonAccionesValidaciones">

    <template v-if="!!!full | !isPC">
      <nav class="ficha-section row-start" :style="ownstyles.nav">
        <template v-if="this.$route.name == 'ofertas-practicas-tutor'">
          <a @click="actual = ['datos-generales']" class="section-nav-el" :active="actual.some(e => e == 'datos-generales')">Datos Generales</a>
          <a @click="actual = ['requisitos']" class="section-nav-el" :active="actual.some(e => e == 'requisitos')">Requisitos</a>
          <a @click="actual = ['candidatos']" class="section-nav-el" :active="actual.some(e => e == 'candidatos')">Candidatos</a>
        </template>
        <template v-else>
          <a @click="actual = ['estudiante']" class="section-nav-el"
          :active="actual.some(e => e == 'estudiante')" v-html="$t('ficha.estudiante')"></a>
        <a @click="actual = ['practica']" class="section-nav-el"
          :active="actual.some(e => e == 'practica')" v-html="$t('ficha.practica')"></a>
        <a @click="actual = ['empresa']" class="section-nav-el" :active="actual.some(e => e == 'empresa')" v-html="$t('ficha.empresa')"></a>
        <a @click="actual = ['observaciones']" class="section-nav-el"
          :active="actual.some(e => e == 'observaciones')" v-html="$t('ficha.observaciones')"></a>
        </template>
      </nav>
    </template>

    <template v-else>
      <nav class="ficha-section row-start" :style="ownstyles.nav">
        <template v-if="this.$route.name ==  'ofertas-practicas-tutor'">
          <a @click="actual = ['datos-generales']" class="section-nav-el" :active="actual.some(e => e == 'datos-generales')">Datos Generales</a>
          <a @click="actual = ['requisitos']" class="section-nav-el" :active="actual.some(e => e == 'requisitos')">Requisitos</a>
          <a @click="actual = ['candidatos']" class="section-nav-el" :active="actual.some(e => e == 'candidatos')">Candidatos</a>
        </template>
        <template v-else>
          <a @click="toggleFicha('estudiante')" class="section-nav-el"
          :active="actual.some(e => e == 'estudiante')" v-html="$t('ficha.estudiante')"></a>
        <a @click="toggleFicha('practica')" class="section-nav-el"
          :active="actual.some(e => e == 'practica')" v-html="$t('ficha.practica')"></a>
        <a @click="toggleFicha('empresa')" class="section-nav-el" :active="actual.some(e => e == 'empresa')" v-html="$t('ficha.empresa')"></a>
        <a @click="toggleFicha('observaciones')" class="section-nav-el"
          :active="actual.some(e => e == 'observaciones')" v-html="$t('ficha.observaciones')"></a>
        </template>
      </nav>
    </template>

    <div class="scroll-container" :full="full" v-if="!!data">

      <template v-if="actual.some(e => e == 'estudiante')">
        <ficha-estudiante :data="data.alumno"></ficha-estudiante>
      </template>

      <template v-if="actual.some(e => e == 'practica')">
        <ficha-practica @setDocumentoPractica="addDocumentoPractica" :data="data.practica" @setEncuesta="setEncuesta">
        </ficha-practica>
      </template>

      <template v-if="actual.some(e => e == 'empresa')">
        <ficha-empresa :data="data.empresa" :contactos="data.contactosOferta"></ficha-empresa>
      </template>

      <template v-if="actual.some(e => e == 'observaciones')">
        <ficha-observaciones :observaciones="data.practica.seguimientoValidacion"></ficha-observaciones>
      </template>

      <template v-if="actual.some(e => e == 'datos-generales')">
        <ficha-datos-generales :data="data"  @refresh="setPractica">
        </ficha-datos-generales>
      </template>
      
      <template v-if="actual.some(e => e == 'requisitos')">
        <ficha-requisitos :data="data" @refresh="setPractica">
        </ficha-requisitos>
      </template>
      <template v-if="actual.some(e => e == 'candidatos')">
        <ficha-candidatos :data="data" @refresh="setPractica">
        </ficha-candidatos>
      </template>

    </div>

    <loading v-else></loading>

    <div class="contenedor-botones row-center" :style="styles.backgroundWhite" v-if="!!showBotonAccionesValidaciones">
      <div class="contenedor">
        <a class="btn -xs" :style="styles.solidPrimary" @click="sendValidar"
          v-if="data.practica.puedeCambiarEstado">{{(!!!brand.changevalidaciontoaceptacion) ? 'Validar' :
          'Aceptar'}}</a>
        <a class="btn -xs" :style="styles.skull_primary" @click="sendRechazar"
          v-if="data.practica.puedeCambiarEstado">Rechazar</a>
      </div>
    </div>

  <div class="contenedor-botones row-center" :style="styles.backgroundWhite"  v-if="!!data.practica && data.practica.idEstadoValidacion == 2">
    <div class="contenedor">

      <template v-if="(brand.OnlytutorLogadoEvalua && data.practica.tutorLogadoEvalua) || !!!brand.OnlytutorLogadoEvalua">
        <a class="btn -xs" :style="styles.solidPrimary" @click="showMarcarEvaluada = true"
        v-if="!data.practica.evaluadaPorTutor || data.practica.evaluadaPorTutor == null" v-html="$t('ficha.marcar_cerrada')"></a>
      </template>

      <a class="btn -xs" :style="styles.solidPrimary" @click="sendMarcarNoEvaluada"
      v-if="data.practica.evaluadaPorTutor" v-html="$t('ficha.marcar_pendiente_cierre')"></a>
    </div>

    <template v-if="!!data.practica">

      <div class="contenedor-botones row-center" :style="styles.backgroundWhite" v-if="!!data.practica && data.practica.idEstadoValidacion == 2">
        <div class="contenedor">
          <a class="btn -xs" :style="styles.solidPrimary" @click="showMarcarEvaluada = true"
            v-if="!data.practica.evaluadaPorTutor || data.practica.evaluadaPorTutor == null" v-html="$t('ficha.marcar_cerrada')"></a>
          <a class="btn -xs" :style="styles.solidPrimary" @click="sendMarcarNoEvaluada"
            v-if="data.practica.evaluadaPorTutor" v-html="$t('ficha.marcar_pendiente_cierre')"></a>
        </div>
      </div>

    </template>

    <div class="contenedor-popup column-center" v-if="showMarcarEvaluada">

      <div class="popup column-center" :style="styles.backgroundWhite">

        <div v-if="!!mensajeEvaluar" v-html="mensajeEvaluar"></div>
        <p v-else v-html="$t('ficha.aviso_marcar_tramitada')"></p>

        <div class="botones row-around">
          <a class="btn -xs"  v-if="!brand.cantcerrarpractica" :style="styles.solidPrimary" @click="sendEvaluada" v-html="$t('ficha.continuar')"></a>
          <a class="btn -xs" :style="styles.skull_primary" @click="showMarcarEvaluada = false" v-html="$t('ficha.cancelar')"></a>
        </div>

      </div>

    </div>
    </div>

    <popup-observaciones :config="popup" v-if="!!popup.action" @cerrar="cerrarPopup"></popup-observaciones>

    <p class="version" :style="styles.colorBasic">{{version}}</p>

  </section>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  import onlyArrow from '@/components/parts/icons/only-arrow';
  import arrowlink from '@/components/parts/icons/arrow-link';

  import fichaEstudiante from '@/components/views/ficha-estudiante';
  import fichaPractica from '@/components/views/ficha-practica';
  import fichaEmpresa from '@/components/views/ficha-empresa';
  import fichaObservaciones from '@/components/views/ficha-observaciones';

  import fichaDatosGenerales from '@/components/views/ficha-datos-generales';
  import fichaRequisitos from '@/components/views/ficha-requisitos';
  import fichaCandidatos  from "@/components/views/ficha-candidatos";

  import popupObservaciones from '@/components/parts/popup-observaciones';

  import loading from '@/components/parts/loading';


  export default {
    name: 'ficha-wrapper',
    props: ['full'],
    mounted() {
      this.setActual();
      this.setPractica();
      window.sessionStorage.removeItem('idPractica');
    },
    data() {
      return {
        actual: [],
        data: '',
        popup: {
          show: false,
          action: ''
        },
        showMarcarEvaluada: false
      }
    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        colors: 'basicColors',
        mensajeEvaluar: 'getmensajeAntesEvaluar',
        version: 'getVersion',
        brand: 'getBrand',
        lang : 'getLanguage'
      }),
      actualLink: function () {
        return `${this.$route.meta.indexPath[this.lang]}/${this.$route.params.status}/${this.$route.params.id}`;
      },
      ownstyles: function () {
        return {
          nav: {
            background: this.colors.white,
            color: this.colors.basic
          }
        }
      },
      showBotonAccionesEvaluadas: function () {
        let show = false;
        if (!!this.data && !!this.data.practica) {
          show = (this.data.practica.evaluadaPorTutor != null) ? true : false;
        }
        return show;
      },
      showBotonAccionesValidaciones: function () {
        let show = false;
        if (!!this.data && !!this.data.practica) {
          show = (this.data.practica.puedeCambiarEstado);
        }
        return show;
      },
      isPC: function () {
        return (window.innerWidth >= 1023);
      }
    },
    methods: {
      ...mapActions(['setMenu', 'requestPractica', 'marcarEvaluada', 'marcarEvaluacionPendiente', 'requestOfertaTutor']),
      setActual: function () {
        if(this.$route.name == 'ofertas-practicas-tutor'){
          this.actual = (!!this.$route.params.section) ? [this.$route.params.section] : ['datos-generales'];
        }
        else{
          this.actual = (!!this.$route.params.section) ? [this.$route.params.section] : ['estudiante'];
        }

        if (this.$route.name == 'ficha') {
          this.setFichas();
        }
      },
      toggleFicha: function (el) {
        if (this.actual.some(e => e == el)) {
          this.actual = this.actual.filter(e => e != el)
        } else {
          this.actual.push(el);
        }

        if (this.actual.length >= 3) {
          this.setMenu(false);
        }
      },
      setFichas: function () {

        let fichas = [];

        if (this.$route.name == 'ofertas-practicas-tutor') {
           fichas = ['datos-generales', 'requisitos', 'info-puesto'];
        }
        else{
           fichas = ['estudiante', 'practica', 'empresa', 'observaciones'];
        }
        if (this.isPC) {
          let cuantas = Math.floor(($(window).width() - 240) / 450);
          this.actual = fichas.slice(0, cuantas);
        } else {
          if (this.$route.name == 'ofertas-practicas-tutor') {
            this.actual = ['datos-generales'];
           }
           else{
            this.actual = ['estudiante'];
           }
        }
      },
      setPractica: function () {

        let id = this.$route.params.id;

        if (!!!id & Number(this.$route.params.status) > 0) {
          id = this.$route.params.status;
        }
        if (this.$route.name == 'ofertas-practicas-tutor'){
          this.requestOfertaTutor(id).then(r => {
            this.data = r;
          })
        }else{
          this.requestPractica(id).then(r => {
            this.data = r;
          })
        }
      },
      sendValidar: function () {
        this.popup.action = 'validar';
      },
      sendRechazar: function () {
        this.popup.action = 'rechazar';
      },
      sendEvaluada: function () {

        let id = this.$route.params.id;

        if (!!!id & Number(this.$route.params.status) > 0) {
          id = this.$route.params.status;
        }

        this.marcarEvaluada(id).then(r => {
          this.showMarcarEvaluada = false;
          // this.$emit("cerrarFicha");
        });
      },
      sendMarcarNoEvaluada: function () {
        this.marcarEvaluacionPendiente(this.$route.params.id).then(r => {

        });
      },
      setEncuesta: function (value) {
        this.$emit('setEncuesta', value)
      },
      addDocumentoPractica(value) {
        this.data.practica.documentacion.push(value);
        this.setPractica();
      },
      cerrarPopup() {
        this.popup.action = '';
      }
    },
    components: {
      'only-arrow': onlyArrow,
      'arrow-link': arrowlink,
      'ficha-estudiante': fichaEstudiante,
      'ficha-practica': fichaPractica,
      'ficha-empresa': fichaEmpresa,
      'ficha-observaciones': fichaObservaciones,
      'popup-observaciones': popupObservaciones,
      'loading': loading,
      'ficha-datos-generales': fichaDatosGenerales,
      'ficha-requisitos': fichaRequisitos,
      'ficha-candidatos': fichaCandidatos,
    },
    watch: {
      '$route': function () {
        this.data = '';
        this.setActual();
        this.setPractica();
      },
      'full': function () {
        if (this.full) {
          this.setFichas();
        } else {
          this.actual = ['estudiante'];
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .ficha-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    padding-bottom: 0px;
    padding-top: 45px;

    &[showBotones="true"] {
      padding-bottom: 60px;
    }
  }

  .ficha-section {
    width: 100%;
    padding: 20px 10px 0 10px;
    position: absolute;
    left: 0;
    top: 0;
    -webkit-flex-wrap: nowrap;
    -moz-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    -o-flex-wrap: nowrap;
    flex-wrap: nowrap;

    a {
      text-transform: uppercase;
      font-weight: 300;
      font-size: 10px;
      height: 25px;
      line-height: 25px;
      padding: 0 5px;
      color: currentColor;
      border-bottom: 1px solid currentColor;
      width: 100%;
    }

    a.router-link-exact-active,
    a[active=true] {
      font-weight: 600;
      position: relative;

      &::before {
        height: 3px;
        width: 100%;
        background: currentColor;
        display: inline-block;
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
  }



  .contenedor-botones {
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 20px;
    padding-bottom: 10px;
    height: auto;


    .contenedor {
      position: relative;
      max-width: 500px;
      display: inline-block;
      width: 100%;
    }

    a {
      margin: 0 15px;
      margin-bottom: 0;
    }

    .next {
      font-size: 12px;
      position: absolute;
      right: 0;
      top: 50%;
      margin: 0;
      margin-top: -22px;
      height: 40px;
      width: 40px;
      line-height: 40px;

      svg {
        height: 25px;
        width: 25px;
      }
    }

    .prev {
      position: absolute;
      left: 0;
      top: 50%;
      margin: 0;
      margin-top: -19px;
      transform: rotate(-180deg);
      height: 40px;
      width: 40px;
      line-height: 40px;

      svg {
        height: 25px;
        width: 25px;
      }
    }
  }

  .scroll-container {
    width: 100%;
    height: 100%;
    min-height: 100%;
    overflow: scroll;
    display: inline-block;
    padding: 10px;
    max-height: calc(100vh - 175px);
  }

  .contenedor-popup {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 100;
    padding: 20px;

    .popup {
      width: 100%;
      max-width: 600px;
      padding: 40px;

      .botones {
        margin-top: 30px;
        max-width: 270px;
        width: 100%;
      }

    }
  }

  .version {
    position: absolute;
    right: 0;
    bottom: 0;
    left: auto;
    pointer-events: none;
  }

  @media screen and (max-width: 1400px) {
    .scroll-container {
      max-height: calc(100vh - 199px);
    }

    .ficha-wrapper {
      &[showBotones="true"] {
        padding-bottom: 41px;
      }
    }

    .contenedor-botones {
      padding: 10px;
      padding-bottom: 0;
    }
  }

  @media screen and (max-width: 600px) {

    .ficha-wrapper {
      padding-top: 32px;

      &[showBotones="true"] {
        padding-bottom: 41px;
      }
    }

    .scroll-container {
      max-height: calc(100vh - 208px);
    }

    .contenedor-popup .popup {
      padding: 20px;
    }
  }

  @media screen and (max-width: 430px) {
    .ficha-section {
      padding: 10px 0 0 0;
    }

    .scroll-container {
      padding: 10px 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/contenedor-ficha.vue